(function($){
	//Handle the mobile menu toggling
	$("#nav-icon").click(function() {
		mainNav();
	});

	function mainNav() {
		$(".main-menu-toggle").toggleClass("cross");
		$("body").toggleClass("modal-open");
		$("#mobile-navigation").toggleClass("open");
		if( $("header:not(.is-sticky) #mobile-navigation.open") ) {
			let topOffset = $("#mobile-navigation.open").offset();
			let menuHeight = $(window).height() - topOffset.top;
			$("#mobile-navigation.open").height(menuHeight);
		}
	}

	$(".mobile-primary > ul > li.menu-item-has-children > a").click(function(e) {
		e.preventDefault();

		$(this).parent().toggleClass('open');
		$(this).next().toggleClass('open');
	});

	$('nav#site-navigation nav.ubermenu .ubermenu-nav').on( 'ubermenuclose', function() {
		// Don't remember last active tab		
		$('nav#site-navigation nav.ubermenu .ubermenu-nav .ubermenu-tabs-group .ubermenu-tab').removeClass('ubermenu-active')	
	})

	// Show first, hidden panel unless a tab's submenu is being displayed
	$('nav#site-navigation nav.ubermenu .ubermenu-nav .ubermenu-tabs-group .ubermenu-tab.ubermenu-item-has-children:not(.hidden)').hover(
		function() {
			$('nav#site-navigation nav.ubermenu .ubermenu-nav .ubermenu-tabs-group .ubermenu-tab.hidden .ubermenu-tab-content-panel').addClass('hidden')
		}, 
		function() {
			$('nav#site-navigation nav.ubermenu .ubermenu-nav .ubermenu-tabs-group .ubermenu-tab.hidden .ubermenu-tab-content-panel').removeClass('hidden');
			$('nav#site-navigation nav.ubermenu .ubermenu-nav .ubermenu-tabs-group .ubermenu-tab').removeClass('ubermenu-active');
		}
	) ;
	
})(jQuery);
